import { useRef } from "react";
import { Button, Dialog } from "@livingmap/hippo";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setAcknowledgedRouteIntercept } from "../../redux/slices/applicationSlice";
import { RouteIntercept } from "../../redux/services/types";
import styles from "./RouteIntercept.module.scss";

export default function RouteInterceptDialog({
  intercept,
  requestKey,
}: {
  intercept?: RouteIntercept;
  requestKey: string;
}) {
  const dispatch = useAppDispatch();
  const acknowledged = useAppSelector(
    (state) => state.application.acknowledgedRouteIntercept,
  );
  const { t, i18n } = useTranslation();
  const button = useRef<HTMLButtonElement>(null);
  const key = JSON.stringify([
    requestKey,
    intercept?.effectiveDestination,
    intercept?.modal,
  ]);
  const modal = intercept?.modal;
  if (!modal?.requiresAcknowledgement || acknowledged === key) return null;
  const message = modal.message[i18n.language] || modal.message["en-GB"];
  const title = modal.title[i18n.language] || modal.title["en-GB"];
  return (
    <Dialog
      dataQA="route-intercept-dialog"
      isOpen
      width={360}
      closable={false}
      alternativeClose={false}
      initialFocusRef={button}
      role="alertdialog"
      aria-labelledby="route-intercept-title"
      aria-describedby="route-intercept-message"
      footer={
        <div className={styles.footer}>
          <Button
            ref={button}
            dataQA="route-intercept-confirm"
            size="regular"
            type="primary"
            style="filled"
            text={t("general.confirm_text", { defaultValue: "Confirm" })}
            onClick={() => dispatch(setAcknowledgedRouteIntercept(key))}
          />
        </div>
      }
      className={styles.dialog}
    >
      <div className={styles.message}>
        <h2 id="route-intercept-title" dir="auto">
          {title}
        </h2>
        <p id="route-intercept-message" dir="auto">
          {message}
        </p>
      </div>
    </Dialog>
  );
}
